<template>
    <div>
        <!-- 这个组件是一个包装器，不包含实际的 DOM 元素 -->
    </div>
</template>

<script>
export default {
    name: 'LoadingOverlay',
    data() {
        return {
            loadingInstance: null
        }
    },
    methods: {
        /**
         * 显示全屏加载遮罩
         * @param {Object} options - 配置选项
         * @param {String} options.text - 加载文本
         * @param {String} options.background - 背景色
         * @param {String} options.spinner - spinner类型
         * @param {Boolean} options.lock - 是否锁定屏幕
         * @returns {Object} 加载实例，可用于手动关闭
         */
        show(options = {}) {
            const defaultOptions = {
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            }

            // 合并默认选项和用户选项
            const mergedOptions = { ...defaultOptions, ...options }

            // 如果已经有一个正在显示，先关闭它
            if (this.loadingInstance) {
                this.loadingInstance.close()
            }

            // 创建新的加载实例
            this.loadingInstance = this.$loading(mergedOptions)

            return this.loadingInstance
        },

        /**
         * 关闭加载遮罩
         */
        hide() {
            if (this.loadingInstance) {
                this.loadingInstance.close()
                this.loadingInstance = null
            }
        }
    }
}
</script>
